export default __webpack_public_path__ + "static/posterMaraMemento-44330de81c48b0067582a584e63588fe.svg";